import Table from '@utils/table'
import TableSelect from '@utils/table-select'
import Operation from '@utils/common/operation'

function remove(this: any, row: any, index: number) {
  const value = [...this.value]
  value.splice(index, 1)
  this.$emit('input', value)
}

const operation = new Operation()
  .add('release').label('common.remove').handle(remove)

function filter(selection: any[], data: any[]) {
  const set = new Set(data.map(i => i.qualitativeItemNo))
  return selection.filter(i => !set.has(i.qualitativeItemNo)).map(item => {
    return { ...item, id: '', qualitativeItemId: item.id, weight: 0 }
  })
}

const dialogTable = new Table('performance.qualitativeFormula')
  .sortable(false)
  .add('qualitativeItemNo')
  .add('qualitativeItemName')
  .lib('remarks')

const table = new Table('performance.qualitativeFormula', true)
  .sortable(false)
  .add('qualitativeItemNo')
  .add('qualitativeItemName')
  .add('weight').editor('el-input-number').attrs({ controlsPosition: 'right', min: 0 })

const tableSelect = new TableSelect('performance.qualitativeFormula')
  .url('/srmQualitativeItem/getSrmQualitativeItemList', process.env.VUE_APP_PURCHASE_API)
  .title('detail')
  .dialogTitle('addDetail')
  .table(table)
  .operation(operation)
  .dialogTable(dialogTable)
  .filter(filter)

export default tableSelect
